import { ReactElement } from 'react'
import { I18n } from 'common'
import { defaultTheme } from '../../../../../../src/theme/index'
import { Price } from '../../../../../../src/ui-components/products/Price'
import { useUserStore } from '../../../../../../src/store/user/UserStore'
import styled from 'styled-components'

interface CartFooterProps {
  total: number
}

export const CartFooter = ({ total }: CartFooterProps): ReactElement => {
  const userStore = useUserStore()
  const displayExclTax = userStore?.preferences?.displayExclTax === 'true'
  return (
    <Footer>
      <TotalPriceWrapper>
        <I18n name="cartTotal" />: &nbsp;
        <PriceColumn>
          <Price num={total} />
          {displayExclTax && (
            <ExclTaxText>
              <I18n name="displayExclTax" />
            </ExclTaxText>
          )}
        </PriceColumn>
      </TotalPriceWrapper>
    </Footer>
  )
}

const Footer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 20px 10px 20px;
  background-color: ${defaultTheme.colors.primaryText};
  color: ${defaultTheme.colors.secondary};
  font-family: Oswald, serif;
  font-weight: bold;
  font-size: 20px;
`

const TotalPriceWrapper = styled.div`
  margin-right: 11px;
  display: flex;
  align-items: flex-start;
`

const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const ExclTaxText = styled.span`
  font-style: italic;
  font-weight: 400;
  font-size: 11px;
  color: ${defaultTheme.colors.secondary};
  text-transform: none;
`
